import { useState, useEffect, useCallback } from "react";
import {
  fetchApiChannels,
  createApiChannel,
  updateApiChannel,
} from "../Services/APIService";
import { ApiChannel, ApiChannelFormData } from "../types/apiChannel.types";

export const useApiChannelTable = () => {
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [searchText, setSearchText] = useState("");
  const [apiChannels, setApiChannels] = useState<ApiChannel[]>([]);
  const [filteredApiChannels, setFilteredApiChannels] = useState<ApiChannel[]>(
    []
  );
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [editApiChannelData, setEditApiChannelData] =
    useState<ApiChannel | null>(null);
  const [selectedRows, setSelectedRows] = useState<ApiChannel[]>([]);
  const [toggleCleared, setToggleCleared] = useState(false);

  const fetchApiChannelData = useCallback(async () => {
    setLoading(true);
    try {
      const data = await fetchApiChannels();
      setApiChannels(data.apiChannels || []);
    } catch (err) {
      setError("Failed to fetch API channels");
      console.error(err);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchApiChannelData();
  }, [fetchApiChannelData]);

  useEffect(() => {
    setFilteredApiChannels(
      apiChannels.filter(
        (channel) =>
          channel.channelName
            .toLowerCase()
            .includes(searchText.toLowerCase()) ||
          channel.apiTypeName.toLowerCase().includes(searchText.toLowerCase())
      )
    );
  }, [searchText, apiChannels]);

  const handleRowSelected = (state: { selectedRows: ApiChannel[] }) => {
    setSelectedRows(state.selectedRows);
  };

  const handleEdit = (apiChannel: ApiChannel) => {
    setEditApiChannelData(apiChannel);
    setIsEditModalOpen(true);
  };

  const toggleSidebar = () => setIsSidebarCollapsed(!isSidebarCollapsed);

  return {
    isSidebarCollapsed,
    toggleSidebar,
    isLoading,
    loading,
    error,
    searchText,
    setSearchText,
    filteredApiChannels,
    fetchApiChannelData,
    isModalOpen,
    setIsModalOpen,
    isEditModalOpen,
    setIsEditModalOpen,
    editApiChannelData,
    setEditApiChannelData,
    selectedRows,
    toggleCleared,
    handleRowSelected,
    handleEdit,
  };
};